import React, { PropsWithChildren, ReactNode } from 'react'
import clsx from 'clsx'
import { Loader } from '../Loader'
import { SVGIcon } from '../SVGIcon'
import { SVGIconConditionalProps } from '../SVGIcon/types/SVGIcon.types'
import styles from './styles/IconAnchor.module.scss'

type IconAnchorProps = PropsWithChildren & {
  href: string
  preLink?: ReactNode
  preLinkClassName?: string
  iconProps?: SVGIconConditionalProps
  iconPosition?: 'left' | 'right'
  svgLinkColor?: boolean
  linkTextClassName?: string
  underline?: boolean
  isLoading?: boolean
  className?: string
  highlight?: boolean
  onClick?: () => void
}

export const IconAnchor: React.FC<IconAnchorProps> = props => {
  const {
    href,
    iconProps,
    iconPosition = 'left',
    preLink,
    preLinkClassName,
    children,
    className,
    isLoading,
    onClick,
    underline,
    svgLinkColor,
    linkTextClassName,
    ...rest
  } = props

  return (
    <div
      onClick={onClick}
      data-render-variant="icon"
      className={clsx(styles.iconAnchor, svgLinkColor && styles.svgLinkColor, className)}
      {...rest}
    >
      {isLoading && <Loader variant="dark" />}
      <a href={href} rel="nofollow">
        <div className={clsx(styles.iconAndLink, styles[iconPosition])}>
          {iconProps?.name && <SVGIcon {...iconProps} />}
          <span className={styles.linkContainer}>
            {preLink && <span className={clsx(styles.preLink, preLinkClassName)}>{preLink}</span>}
            <span
              className={clsx(
                styles.link,
                styles.linkText,
                isLoading && styles.linkDisabled,
                underline && !isLoading && styles.underline,
                linkTextClassName
              )}
            >
              {children}
            </span>
          </span>
        </div>
      </a>
    </div>
  )
}
